import axios from 'axios'

export const HTTP = axios.create({
  baseURL: '/',
//  baseURL: 'http://localhost:8080/',
//  baseURL: 'https://hawkeye.teedrei.com/',
  headers: {
    // Authorization: 'Basic ' + credentials
  }
})



// WEBPACK FOOTER //
// ./src/services/HttpService.js